// Test IDs for Aegis One dashboard views.
export const NAV = {
    logo: 'nav-logo',
    home: 'nav-home',
    explorer: 'nav-explorer',
    validators: 'nav-validators',
    stake: 'nav-stake',
    treasury: 'nav-treasury',
    tokenomics: 'nav-tokenomics',
    ai: 'nav-ai',
    studio: 'nav-studio',
    economics: 'nav-economics',
    investors: 'nav-investors',
    wallet: 'nav-wallet',
    connect: 'nav-connect-button',
    userMenu: 'nav-user-menu',
    logout: 'nav-logout-button',
    faucet: 'nav-faucet-button',
    search: 'nav-search-input',
};

export const HOMEPAGE = {
    heroCta: 'home-hero-cta',
    heroSecondaryCta: 'home-hero-secondary-cta',
    statHeight: 'home-stat-height',
    statTps: 'home-stat-tps',
    statValidators: 'home-stat-validators',
    statStaked: 'home-stat-staked',
    productCard: (name) => `home-product-${name}`,
    sectorCard: (key) => `home-sector-${key}`,
};

export const EXPLORER = {
    tabBlocks: 'explorer-tab-blocks',
    tabTxs: 'explorer-tab-txs',
    blockRow: (h) => `explorer-block-row-${h}`,
    txRow: (h) => `explorer-tx-row-${h}`,
    searchInput: 'explorer-search-input',
    searchSubmit: 'explorer-search-submit',
};

export const VALIDATORS = {
    row: (id) => `validator-row-${id}`,
    delegateBtn: (id) => `validator-delegate-btn-${id}`,
};

export const STAKE = {
    validatorSelect: 'stake-validator-select',
    amountInput: 'stake-amount-input',
    stakeBtn: 'stake-submit-btn',
    positionRow: (id) => `stake-position-${id}`,
    unstakeBtn: (id) => `stake-unstake-btn-${id}`,
    claimBtn: (id) => `stake-claim-btn-${id}`,
    maxBtn: 'stake-max-btn',
};

export const TREASURY = {
    bucketCard: (b) => `treasury-bucket-${b}`,
    actionRow: (id) => `treasury-action-${id}`,
};

export const TOKENOMICS = {
    chart: 'tokenomics-chart',
    breakdownRow: (b) => `tokenomics-breakdown-${b}`,
};

export const AI = {
    openBtn: 'ai-open-btn',
    input: 'ai-message-input',
    sendBtn: 'ai-send-btn',
    message: (i) => `ai-message-${i}`,
    newSession: 'ai-new-session',
    sessionRow: (id) => `ai-session-${id}`,
};
